import React from "react"

const Suspense = ({ children, fallback = <div>...</div> }) => {
	return <React.Suspense fallback={fallback}>{children}</React.Suspense>
}

export default Suspense
